import { render, staticRenderFns } from "./SaveAdDropdown.vue?vue&type=template&id=91936874&scoped=true"
import script from "./SaveAdDropdown.vue?vue&type=script&lang=js"
export * from "./SaveAdDropdown.vue?vue&type=script&lang=js"
import style0 from "./SaveAdDropdown.vue?vue&type=style&index=0&id=91936874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91936874",
  null
  
)

export default component.exports